<div class="document-container">
  @if (showContentAddresses) {
    <div>
      <div class="id-content">
        <div class="icon">
          <img src="assets/icons/user.svg" alt="contact">
        </div>
        <div class="type-text">
          <div fiMaskSearched="{{getAddress(Lead.Lead)}}" [categoryName]="'Address'">{{getAddress( Lead.Lead )}}</div>
        </div>
      </div>
    </div>
  }


  @if (showDetailContent) {
    <div class="contact-detail">
      <div class="contact-content">
        @if (Lead.Lead.Contact?.Email && !Lead.Lead.Contact?.Email?.endsWith('@temp.finstral.com')) {
          <span
            class="info-line mail" #mail [isTitle]="true" fiTranslation="ALT_TEXT_CONTACT_DETAIL_EMAIL"
            (mousemove)="tooltip.show()"
            (mouseleave)="tooltip.hide()">
            <div matTooltip="{{ mail.dataset.matTooltip }}" #tooltip="matTooltip"
              [matTooltipShowDelay]="100"
              class="custom-tooltip" matTooltipPosition="below" matTooltipClass='tooltip-style'>
            </div>
            <a class="custom-link" [class.prefer]="Lead.Lead.Contact?.ContactMethodName === 'E-MAIL'"
              href="mailto: {{ Lead.Lead.Contact?.Email }}">
              <span fiMaskSearched="{{Lead.Lead.Contact.Email}}"
              [categoryName]="'Contact'">{{Lead.Lead.Contact.Email}}</span>
            </a>
            @if (Lead.Lead.Contact?.ContactMethodName === 'E-MAIL') {
              <span class="prefer-contact"
              fiTranslation="REQUEST_DETAIL_HEADLINE_PREFERENCE"></span>
            }
          </span>
        } @else {
          @if (Lead.Lead.Contact?.Email) {
            <span class="info-line mail default-email">
              <span fiTranslation="CONTACT_ERRORMSG_HEADLINE_NO_EMAIL"></span>
            </span>
          }
        }
        @if (Lead.Lead.Contact?.AdditionalEmail && !Lead.Lead.Contact?.AdditionalEmail?.endsWith('@temp.finstral.com')) {
          <span
            class="info-line mail" #mail [isTitle]="true" fiTranslation="ALT_TEXT_CONTACT_DETAIL_EMAIL"
            (mousemove)="tooltip.show()"
            (mouseleave)="tooltip.hide()">
            <div matTooltip="{{ mail.dataset.matTooltip }}" #tooltip="matTooltip"
              [matTooltipShowDelay]="100"
              class="custom-tooltip" matTooltipPosition="below" matTooltipClass='tooltip-style'>
            </div>
            <a class="custom-link" href="mailto: {{ Lead.Lead.Contact?.AdditionalEmail }}">
              <span fiMaskSearched="{{ Lead.Lead.Contact?.AdditionalEmail }}"
              [categoryName]="'Contact'">{{ Lead.Lead.Contact?.AdditionalEmail }}</span>
            </a>
          </span>
        }
        @if (contactPhone) {
          <span class="info-line telephone" #telephone [isTitle]="true"
            fiTranslation="ALT_TEXT_CONTACT_DETAIL_PHONE"
            (mousemove)="tooltip.show()"
            (mouseleave)="tooltip.hide()">
            <div matTooltip="{{ telephone.dataset.matTooltip }}" #tooltip="matTooltip"
              [matTooltipShowDelay]="100"
              class="custom-tooltip" matTooltipPosition="below" matTooltipClass='tooltip-style'>
            </div>
            <a class="custom-link" href="tel: {{ contactPhone }}">
              <span fiMaskSearched="{{ contactPhone }}" [categoryName]="'Contact'">{{ contactPhone }}</span>
            </a>
            @if (Lead.Lead.Contact?.ContactMethodName === 'TELEFON') {
              <span class="prefer-contact"
              fiTranslation="REQUEST_DETAIL_HEADLINE_PREFERENCE"></span>
            }
          </span>
        }
        @if (contactMobile) {
          <span class="info-line phone" #mobile [isTitle]="true"
            fiTranslation="ALT_TEXT_CONTACT_DETAIL_MOBIL"
            (mousemove)="tooltip.show()"
            (mouseleave)="tooltip.hide()">
            <div matTooltip="{{ mobile.dataset.matTooltip }}" #tooltip="matTooltip"
              [matTooltipShowDelay]="100"
              class="custom-tooltip" matTooltipPosition="below" matTooltipClass='tooltip-style'>
            </div>
            <a class="custom-link" href="tel: {{ contactMobile }}">
              <span fiMaskSearched="{{ contactMobile }}" [categoryName]="'Contact'">{{ contactMobile }}</span>
            </a>
            @if (Lead.Lead.Contact?.ContactMethodName === 'MOBILE') {
              <span class="prefer-contact"
              fiTranslation="REQUEST_DETAIL_HEADLINE_PREFERENCE"></span>
            }
          </span>
        }
      </div>
    </div>
  }



  @if (highlightedDocuments?.length) {
    <div class="contact-detail">
      <div class="contact-content documents">
        @for (fileName of highlightedDocuments; track fileName) {
          <span class="info-line document"
            (mousemove)="tooltip.show()"
            (mouseleave)="tooltip.hide()">
            <div matTooltip="{{ 'Dokument' }}" #tooltip="matTooltip"
              [matTooltipShowDelay]="100"
              class="custom-tooltip" matTooltipPosition="below" matTooltipClass='tooltip-style'>
            </div>
            <a class="custom-link" href="javascript:void(0)">
              <span fiMaskSearched="{{ fileName }}" [categoryName]="'All'"></span>
            </a>
          </span>
        }
      </div>
    </div>
  }



  @if (highlightedNotes?.length) {
    <div class="contact-detail">
      <div class="contact-content notes">
        @for (note of highlightedNotes; track note) {
          <span
            class="info-line note"
            (mousemove)="tooltip.show()"
            (mouseleave)="tooltip.hide()">
            <div matTooltip="{{ 'Note' }}" #tooltip="matTooltip"
              [matTooltipShowDelay]="100"
              class="custom-tooltip" matTooltipPosition="below" matTooltipClass='tooltip-style'>
            </div>
            <a class="custom-link" href="javascript:void(0)">
              <span fiMaskSearched="{{ note }}" [categoryName]="'All'"></span>
            </a>
          </span>
        }
      </div>
    </div>
  }
</div>
